import { api } from '@bilibili-maoer/web-utils';
import { getFetch } from '../../../utils/fetcher.js';
import '@babel/runtime-corejs3/core-js/instance/concat';

var getFeed = function getFeed(id) {
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/mperson/getfeed"),
    params: {
      id: id
    }
  });
};

export { getFeed };
